import { render, staticRenderFns } from "./NowDeliveryList.vue?vue&type=template&id=bacad756&scoped=true"
import script from "./NowDeliveryList.vue?vue&type=script&lang=js"
export * from "./NowDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./NowDeliveryList.vue?vue&type=style&index=0&id=bacad756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacad756",
  null
  
)

export default component.exports